import { Component, Input } from '@angular/core';
import { TranslationService } from '@core/services/local/translation.service';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { navTabConfig } from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';
import { NgComponentOutlet } from '@angular/common';

@Component({
  selector: 'nav-tab-component',
  templateUrl: './nav-tab.component.html',
  imports: [NgbNavModule, TranslateModule, NgComponentOutlet],
  styleUrls: ['./nav-tab.component.scss'],
})
export class CustomNabTabComponent {
  @Input({ required: true }) config!: navTabConfig[];

  constructor(private translate: TranslationService) {}

  
}
